var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerCent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "url(#paint0_linear_42_13499)",
    stroke: "url(#paint1_linear_42_13499)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2775 19.7864C41.7117 19.0808 41.4917 18.1569 40.7861 17.7227C40.0806 17.2885 39.1567 17.5085 38.7225 18.2141L22.7225 44.2141C22.2883 44.9196 22.5083 45.8435 23.2139 46.2777C23.9194 46.7119 24.8433 46.4919 25.2775 45.7864L41.2775 19.7864ZM19 25.0002C19 27.2093 20.7909 29.0002 23 29.0002C25.2091 29.0002 27 27.2093 27 25.0002C27 22.7911 25.2091 21.0002 23 21.0002C20.7909 21.0002 19 22.7911 19 25.0002ZM23 18.0002C19.134 18.0002 16 21.1342 16 25.0002C16 28.8662 19.134 32.0002 23 32.0002C26.866 32.0002 30 28.8662 30 25.0002C30 21.1342 26.866 18.0002 23 18.0002ZM37 39.0002C37 41.2094 38.7909 43.0002 41 43.0002C43.2091 43.0002 45 41.2094 45 39.0002C45 36.7911 43.2091 35.0002 41 35.0002C38.7909 35.0002 37 36.7911 37 39.0002ZM41 32.0002C37.134 32.0002 34 35.1342 34 39.0002C34 42.8662 37.134 46.0002 41 46.0002C44.866 46.0002 48 42.8662 48 39.0002C48 35.1342 44.866 32.0002 41 32.0002Z",
    fill: "url(#paint2_linear_42_13499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_13499",
    x1: 56.96,
    y1: 0.00000108547,
    x2: -6.34387,
    y2: 28.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_13499",
    x1: 13.44,
    y1: -3.58094e-8,
    x2: 7.13874,
    y2: 61.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_13499",
    x1: 22.72,
    y1: 17.5,
    x2: 20.1275,
    y2: 45.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerCent);
export default __webpack_public_path__ + "static/media/per-cent.7aacfd3c4d77a59e328454813e11cd54.svg";
export { ForwardRef as ReactComponent };